import { stripCpfDigits } from '@/Pages/Signup/utils/cpfMask';
import { stripPhoneDigits } from '@/Pages/ParentalConsent/utils/phoneMask';
import type {
  NormalizedParentalConsentFormData,
  ParentalConsentFormData,
} from '@/types/parental-consent';

function collapseWhitespace(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

export function normalizeParentalConsentFormData(
  form: ParentalConsentFormData,
): NormalizedParentalConsentFormData {
  if (form.guardianRelationship === '') {
    throw new Error('guardianRelationship is required');
  }
  return {
    guardianFullName: collapseWhitespace(form.guardianFullName),
    guardianEmail: form.guardianEmail.trim().toLowerCase(),
    guardianCpf: stripCpfDigits(form.guardianCpf),
    guardianPhone: stripPhoneDigits(form.guardianPhone),
    guardianRelationship: form.guardianRelationship,
    consentGiven: form.consentGiven,
  };
}
